<template>
  <div class="parc-list">

    <div  v-if="!sub">

      <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
        <PrinterFilterForm
            ref="filterForm"
            :values="filters"
            slot="filter"
        />
      </DataFilter>
      <br/>
    </div>
    <v-card >

      <div v-if="sub">
        <v-app-bar flat >
          <v-icon>mdi-printer-3d</v-icon>
          <v-toolbar-title class="title pl-1">
            {{$t('menu.printers')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>
      </div>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" xs="12" :sm="sizecolSm" :md="sizecolMd" v-for="printer in printers" :key="printer.id">
              <printerCard ref="printerCard" :printer="printer" :supervision="supervision"></printerCard>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import FileMixin from '../../mixins/FileMixin';
import printerCard from './printerCard';
import DataFilter from "@/components/DataFilter.vue";
import PrinterFilterForm from "@/components/printer/Filter.vue";


export default {
  name: 'PrinterList',
  servicePrefix: 'Printer',
  mixins: [ListMixin,FileMixin],
  components: {
    PrinterFilterForm,
    DataFilter,
    printerCard
  },
  props: {
    supervision: {
      type: Boolean,
      required: false,
      default: () => false
    },
    sub: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    this.getPrinters({'itemsPerPage': '50','order[name]': 'asc'});
    this.pollData();
  },
  computed: {
    ...mapGetters('printer', {
      printers: 'list'
    }),
    ...mapFields('printer', {
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    sizecolMd() {
      if (this.sub) return 6
      else return 3
    },
    sizecolSm() {
      if (this.sub) return 12
      else return 6
    },

    progressPrint(printer) {
      console.log(printer);
      if (printer) {
        if (printer.layerTotal > 0) {
          return Math.round((printer.layerPrint * 100) / printer.layerTotal);
        }
      }
      return 0;

    },
  },

  methods: {
    ...mapActions('printer', {
      getPrinters: 'fetchAll',
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    pollData () {

      // Si la page n'est pas actif, on ne recherche pas de nouvelles notifications
      if (!document.hidden) {

        this.polling = setInterval(() => {
          if (!document.hidden) {

            this.getPrinters({'itemsPerPage': '50','order[name]': 'asc'})
          }
        }, 15000);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
};
</script>
